module.exports = __webpack_public_path__ + "static/images/head-bg.dcd2279.jpg";